import React, { useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import logoMark from "../../assets/images/hotelsriver-logo-optimized.svg";

/**
 * Sample room photos. Official hotel-site images replace this list later.
 */
export default function HubwayzRoomPhotoSlider({ images = [], label = "תמונות החדר" }) {
  const photos = Array.isArray(images) ? images.filter(Boolean) : [];
  const [index, setIndex] = useState(0);
  if (!photos.length) {
    return (
      <div
        className="hwz-room-slider hwz-room-empty"
        role="img"
        aria-label="חדר ללא תמונות"
        data-testid="hwz-room-empty"
      >
        <img className="hwz-room-empty__mark" src={logoMark} alt="" />
        <span className="hwz-room-empty__label">חדר ללא תמונות</span>
      </div>
    );
  }

  const safeIndex = Math.min(index, photos.length - 1);
  const step = (event, delta) => {
    event.preventDefault();
    event.stopPropagation();
    setIndex((current) => (current + delta + photos.length) % photos.length);
  };

  return (
    <div
      className="hwz-room-slider"
      dir="ltr"
      role="group"
      aria-label={label}
      data-testid="hwz-room-slider"
    >
      <img src={photos[safeIndex]} alt="" />
      {photos.length > 1 ? (
        <>
          <button
            type="button"
            className="hwz-room-slider__nav hwz-room-slider__nav--prev"
            aria-label="תמונה קודמת"
            onClick={(event) => step(event, -1)}
          >
            <LeftOutlined />
          </button>
          <button
            type="button"
            className="hwz-room-slider__nav hwz-room-slider__nav--next"
            aria-label="תמונה הבאה"
            onClick={(event) => step(event, 1)}
          >
            <RightOutlined />
          </button>
          <span className="hwz-room-slider__count">
            {safeIndex + 1} / {photos.length}
          </span>
        </>
      ) : null}
    </div>
  );
}
